import React, { FC } from 'react';
import { TypeLandingPageHeroFields } from '@/core/generated-types';
import { getMediaComponent } from '@/components/common/LandingPageHero/utils';
import { UniversalCta } from '../../UniversalCta';
import { HeaderSize, HeaderText } from '@/components/ui/HeaderText';

export const SideBySide: FC<TypeLandingPageHeroFields> = ({
  entryName,
  media,
  subHeaderText,
  headerText,
  subtext,
  cta,
  textBelowCta,
}) => {
  return (
    <section
      data-testid={`landing-page-hero-${entryName}`}
      className="mx-auto bg-teal pb-8 text-center lg:pb-0 lg:text-left"
    >
      <div className="relative lg:flex">
        <div className="lg:h-26rem relative mb-6 flex h-[240px] w-full items-center justify-center lg:mb-0 lg:h-[448px] lg:w-1/2">
          {getMediaComponent({ media })}
        </div>
        <div className="items-center justify-start px-8 sm:pl-8 lg:flex lg:w-1/2 lg:pl-12 lg:pr-12 xl:pl-24">
          <div className="lg:max-w-lg">
            {subHeaderText && (
              <HeaderText
                text={subHeaderText}
                size={HeaderSize.H3}
                classes="mb-3 text-center lg:text-left"
              />
            )}
            <h1 className="mb-2 text-d-h2 font-bold lg:text-d-h1">
              {headerText}
            </h1>
            <div className="mx-auto text-d-h4 lg:text-d-lg">{subtext}</div>
            {cta && (
              <div className="mt-6">
                <UniversalCta link={cta} className="inline-flex" />
              </div>
            )}
            {textBelowCta && (
              <div
                className="my-4 text-base text-gray-600 font-bold text-lg"
                dangerouslySetInnerHTML={{ __html: textBelowCta }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
